import { render, staticRenderFns } from "./batchSbcontractor.vue?vue&type=template&id=0b88d76f&scoped=true"
import script from "./batchSbcontractor.vue?vue&type=script&lang=js"
export * from "./batchSbcontractor.vue?vue&type=script&lang=js"
import style0 from "./batchSbcontractor.vue?vue&type=style&index=0&id=0b88d76f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88d76f",
  null
  
)

export default component.exports